import { InternalFeatureMapFeature, InternalFeatureTag } from '../../api/screenshot-links'
import { getFeatureSearchLegacyIds, getSelectedTagLegacyIds, minFeatureSearchLength } from '../../helpers/screenshotLinks'
import { InternalConcept, InternalTag } from '../../types/InternalTag'

// A feature with the choice it's added with.
export type AddFeaturesDialogFeature = {
  legacyId: number
  name: string
  weightId: number
  choice: string
}

export type AddFeaturesDialogConcept = {
  id: string
  name: string
  featureTagId: string | null
}

export type AddFeaturesDialogShow = 'all' | 'features' | 'concepts'

type SearchKeyword = { name: string; linkedIds?: number[] | null }

export const toDialogConcepts = (concepts: InternalConcept[], tags: InternalTag[]): AddFeaturesDialogConcept[] => {
  const tagsById = new Map(tags.map((tag) => [tag.id, tag]))
  return concepts
    .map((concept) => ({
      id: concept.id,
      name: concept.tags.map((id) => tagsById.get(id)?.name).find(Boolean) ?? `#${concept.conceptId}`,
      featureTagId: concept.featureTagId ?? null,
    }))
    .sort((a, b) => a.name.localeCompare(b.name))
}

// As legacy: a search of at least two letters wins over the tags, which filter only while the search is empty.
export const filterDialogFeatures = <T extends Pick<AddFeaturesDialogFeature, 'legacyId' | 'name'>>(
  features: T[],
  { search, selectedTagIds, featureTags, keywords }: { search: string; selectedTagIds: string[]; featureTags: InternalFeatureTag[]; keywords: SearchKeyword[] }
) => {
  const searchable = features.map(({ legacyId, name }) => ({ id: String(legacyId), legacyId, name } as InternalFeatureMapFeature))
  const ids = getFeatureSearchLegacyIds(search, searchable, keywords, featureTags) ?? getSelectedTagLegacyIds(featureTags, selectedTagIds)
  return ids ? features.filter(({ legacyId }) => ids.has(legacyId)) : features
}

export const filterDialogConcepts = (concepts: AddFeaturesDialogConcept[], { search, selectedTagIds }: { search: string; selectedTagIds: string[] }) => {
  const text = search.trim().toLowerCase()
  if (text.length >= minFeatureSearchLength) return concepts.filter(({ name }) => name.toLowerCase().includes(text))
  if (selectedTagIds.length) return concepts.filter(({ featureTagId }) => !!featureTagId && selectedTagIds.includes(featureTagId))
  return concepts
}
